export enum EStockLocationHistoryStatus {
    CURRENT = 'current',
    PREVIOUS = 'previous'
}
